(function () {
  function fmt(n) {
    n = Number(n) || 0;
    return n.toLocaleString('en-US', { maximumFractionDigits: 0 });
  }

  /* Brand search */
  document.addEventListener('input', function (event) {
    var input = event.target;
    if (!input.matches('[data-tbx-filter-search]')) return;
    var list = input.closest('.js-filter, .accordion__content');
    if (!list) return;
    var ul = list.querySelector('.facets__list');
    var q = input.value.trim().toLowerCase();
    if (ul) ul.classList.toggle('is-searching', q !== '');
    list.querySelectorAll('.facets__item').forEach(function (item) {
      var text = (item.getAttribute('data-tbx-option') || item.textContent || '').toLowerCase();
      item.hidden = q !== '' && text.indexOf(q) === -1;
    });
  });

  /* Show more / less */
  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-tbx-show-more]');
    if (!btn) return;
    event.preventDefault();
    var wrap = btn.closest('.js-filter, .accordion__content');
    var ul = wrap && wrap.querySelector('.facets__list');
    if (!ul) return;
    var expanded = ul.classList.toggle('is-expanded');
    btn.innerHTML = (expanded ? btn.dataset.less : btn.dataset.more) + ' <span aria-hidden="true">' + (expanded ? '−' : '+') + '</span>';
  });

  /* Price slider */
  function priceParts(pr) {
    var ranges = pr.querySelectorAll('input[type="range"]');
    var nums = pr.querySelectorAll('input[type="number"]');
    if (ranges.length < 2 || nums.length < 2) return null;
    return { pr: pr, rMin: ranges[0], rMax: ranges[1], nMin: nums[0], nMax: nums[1] };
  }

  function paintPrice(pr) {
    var p = priceParts(pr);
    if (!p) return;
    var max = Number(p.rMax.getAttribute('max')) || Number(pr.dataset.tbxMax) || 0;
    var a = Number(p.rMin.value) || 0;
    var b = p.rMax.value === '' ? max : Number(p.rMax.value);
    if (a > b) { var t = a; a = b; b = t; }
    var slider = pr.querySelector('.tbx-price-slider');
    if (slider && max > 0) {
      slider.style.setProperty('--tbx-min', (a / max * 100).toFixed(2) + '%');
      slider.style.setProperty('--tbx-max', (b / max * 100).toFixed(2) + '%');
    }
    var cur = pr.dataset.tbxCurrency || '';
    var minLabel = pr.querySelector('[data-tbx-price-min-label]');
    var maxLabel = pr.querySelector('[data-tbx-price-max-label]');
    if (minLabel) minLabel.textContent = cur + ' ' + fmt(a);
    if (maxLabel) maxLabel.textContent = cur + ' ' + fmt(b) + (b >= max ? '+' : '');

    var curMin = (p.nMin.value || '').trim();
    var curMax = (p.nMax.value || '').trim();
    pr.querySelectorAll('.tbx-price-chip').forEach(function (chip) {
      var cMin = chip.dataset.min || '';
      var cMax = chip.dataset.max || '';
      var minMatch = (cMin === '' ? (curMin === '' || Number(curMin) === 0) : Number(curMin) === Number(cMin));
      var maxMatch = (cMax === '' ? (curMax === '' || Number(curMax) >= max) : Number(curMax) === Number(cMax));
      chip.classList.toggle('is-active', minMatch && maxMatch && (cMin !== '' || cMax !== ''));
    });
  }

  function syncNumbersFromRanges(pr) {
    var p = priceParts(pr);
    if (!p) return;
    var max = Number(p.rMax.getAttribute('max')) || 0;
    var a = Number(p.rMin.value) || 0;
    var b = Number(p.rMax.value);
    if (a > b) { var t = a; a = b; b = t; }
    p.nMin.value = a > 0 ? a : '';
    p.nMax.value = b < max ? b : '';
  }

  document.addEventListener('input', function (event) {
    var r = event.target;
    if (!r.matches('price-range input[type="range"]')) return;
    var pr = r.closest('price-range');
    syncNumbersFromRanges(pr);
    paintPrice(pr);
  });

  document.addEventListener('click', function (event) {
    var chip = event.target.closest('.tbx-price-chip');
    if (!chip) return;
    event.preventDefault();
    var pr = chip.closest('price-range');
    var p = priceParts(pr);
    if (!p) return;
    var max = Number(p.rMax.getAttribute('max')) || 0;
    var cMin = chip.dataset.min || '';
    var cMax = chip.dataset.max || '';
    if (chip.classList.contains('is-active')) { cMin = ''; cMax = ''; }
    p.nMin.value = cMin;
    p.nMax.value = cMax;
    p.rMin.value = cMin === '' ? 0 : cMin;
    p.rMax.value = cMax === '' ? max : Math.min(Number(cMax), max);
    paintPrice(pr);
    p.nMax.dispatchEvent(new Event('input', { bubbles: true }));
  });

  function initAll() {
    document.querySelectorAll('price-range').forEach(paintPrice);
  }

  function accordionRoot() {
    return document.querySelector('.tbx-collection-page accordion-component');
  }

  function closeOtherAccordions(keep) {
    var root = accordionRoot();
    if (!root) return;
    root.querySelectorAll('.accordion.open, .accordion.is-active').forEach(function (item) {
      if (item === keep) return;
      item.classList.remove('open', 'is-active');
      var content = item.querySelector('.accordion__content');
      if (content) content.style.display = 'none';
    });
    if (keep) {
      keep.classList.add('open', 'is-active');
      var openContent = keep.querySelector('.accordion__content');
      if (openContent) openContent.style.display = 'block';
    }
  }

  function keepOneAccordionOpen() {
    var root = accordionRoot();
    if (!root) return;
    var opens = root.querySelectorAll('.accordion.open, .accordion.is-active');
    if (opens.length <= 1) return;
    var keep = root.querySelector('.collection-sidebar__filter.open') || opens[0];
    closeOtherAccordions(keep);
  }

  document.addEventListener('click', function (event) {
    var title = event.target.closest('.tbx-collection-page .accordion__title');
    if (!title) return;
    var item = title.closest('.accordion');
    if (!item) return;
    setTimeout(function () {
      if (item.classList.contains('open') || item.classList.contains('is-active')) {
        closeOtherAccordions(item);
      }
    }, 0);
  });

  function scrollResultsTop() {
    var el = document.querySelector('.tbx-coll-heading')
      || document.getElementById('CollectionProductGrid')
      || document.getElementById('MainContent');
    var header = document.querySelector('.navigation-header.sticky, .layout-header');
    var offset = header ? header.getBoundingClientRect().height : 0;
    if (!el) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }
    var top = el.getBoundingClientRect().top + window.pageYOffset - offset - 10;
    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
  }

  document.addEventListener('change', function (event) {
    if (!event.target.closest('.tbx-collection-page .facet-checkbox, .tbx-collection-page .mobile-facets__label')) return;
    scrollResultsTop();
  });

  document.addEventListener('click', function (event) {
    if (!event.target.closest('.tbx-collection-page .tbx-price-chip')) return;
    scrollResultsTop();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
      keepOneAccordionOpen();
    });
  } else {
    initAll();
    keepOneAccordionOpen();
  }
})();
